import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { FoodType, foodTypesFilter, foodTypesFilterSelection } from 'app/dataProviders/filter-items'

type Props = {
  id: string
  pending: boolean
}

export const foodTypesSelection: Array<string> = [FoodType.Hot]

export const FoodTypesFilter = ({ id, pending }: Props) => {
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Вид питания"
      header="Выбор вида питания"
      dataBoxData={foodTypesFilter}
      dataBoxSelection={foodTypesFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      defaultSelection={foodTypesSelection}
      disabled={pending}
    />
  )
}
